var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.num > 0)?_c('span',{style:(_vm.num > 5 ? { color: 'rgba(0, 0, 0, 0.65)' } : { color: '#F78626' })},[_vm._v(" 剩余"+_vm._s(_vm.num)+"天 ")]):(_vm.num < 0)?_c('span',{staticStyle:{"color":"#f5222d"}},[_vm._v(" 超期"+_vm._s(Math.abs(_vm.num))+"天 ")]):_c('span',[_vm._v("今日截止")])])
}
var staticRenderFns = []

export { render, staticRenderFns }